import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {NetscopeDashboardComponent} from "./netscope-dashboard/netscope-dashboard.component";
import {NetscopeTopologyComponent} from "./netscope-topology/netscope-topology.component";
import {NetscopeHeatmapViewerComponent} from "./netscope-heatmap-viewer/netscope-heatmap-viewer.component";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {ClarityModule} from "@clr/angular";
import {AppRoutingModule} from "../app-routing.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {ExpandableRowsComponent} from "./netscope-flows-datagrid/expandable-rows/expandable-rows.component";
import {RangeFilterComponent} from "./netscope-flows-datagrid/range-filter/range-filter.component";
import {ResourcesComboboxComponent} from "./netscope-flows-datagrid/resources-combobox/resources-combobox.component";
import {ResourceFilterComponent} from "./netscope-flows-datagrid/resource-filter/resource-filter.component";
import {HeatmapComboboxComponent} from "./netscope-heatmap-viewer/heatmap-combobox/heatmap-combobox.component";
import {
  HeatmapHighchartsHeatmapComponent
} from "./netscope-heatmap-viewer/heatmap-highcharts-heatmap/heatmap-highcharts-heatmap.component";
import {NetscopeCustomProtocolsComponent} from "./netscope-custom-protocols/netscope-custom-protocols.component";
import {
  AppsGroupsComboboxComponent
} from "./netscope-common-flowview/apps-groups-combobox/apps-groups-combobox.component";
import {NetscopeCommonFlowviewComponent} from "./netscope-common-flowview/netscope-common-flowview.component";
import {NetscopeExternalIpsComponent} from "./netscope-external-ips/netscope-external-ips.component";
import {
  ExternalIpsWizardImportCsvComponent
} from "./netscope-external-ips/external-ips-wizard-import-csv/external-ips-wizard-import-csv.component";
import {NetscopeDiagnosticComponent} from "./netscope-diagnostic/netscope-diagnostic.component";
import {NetscopeFlowsDatagridComponent} from "./netscope-flows-datagrid/netscope-flows-datagrid.component";
import {NetscopeThreatCenterComponent} from "@app/netscope/netscope-threat-center/netscope-threat-center.component";
import {
  NetscopeCommonFlowviewLegendComponent
} from "@app/netscope/netscope-common-flowview/netscope-common-flowview-legend/netscope-common-flowview-legend.component";
import {TranslocoModule} from "@ngneat/transloco";
import {NetscopeOutsideFlowsComponent} from '@app/netscope/netscope-outside-flows/netscope-outside-flows.component';
import {NetscopeReportsComponent} from '@app/netscope/netscope-reports/netscope-reports.component';
import {
  DiscreteValuesFilterComponent
} from "@app/netscope/netscope-flows-datagrid/discrete-values-filter/discrete-values-filter.component";
import {
  ThreatsTagsFilterComponent
} from "@app/netscope/netscope-flows-datagrid/threats-tags-filter/threats-tags-filter.component";
import {NgxEchartsModule} from "ngx-echarts";
import {ECHARTS_THEME} from "../helper/echarts-theme";
import {EchartsItemCountDirective} from "../helper/echarts-item-count.directive";
import {MarkdownModule} from 'ngx-markdown';
import {
  AppsGroupElementComponent
} from "@app/netscope/netscope-common-flowview/jointjs-angular/apps-group-element/apps-group-element.component";
import {
  NetscopeFlowsDescriptionsComponent
} from "@app/netscope/netscope-flows-descriptions/netscope-flows-descriptions.component";
import {
  FlowsDescriptionsEditComponentComponent
} from "@app/netscope/netscope-flows-descriptions/flows-descriptions-edit-component/flows-descriptions-edit-component.component";
import {
  FlowsDescriptionsNetworkRuleEditComponent
} from "@app/netscope/netscope-flows-descriptions/flows-descriptions-network-rule-edit/flows-descriptions-network-rule-edit.component";
import {AppsGroupRefComponent} from "@app/netscope/netscope-flows-descriptions/apps-group-ref/apps-group-ref.component";
import {
  AppsGroupsPanelComponent
} from "@app/netscope/netscope-common-flowview/apps-groups-panel/apps-groups-panel.component";
import {CodeEditorModule} from '@acrodata/code-editor';
import {
  AppsGroupsFilesNavComponent
} from "@app/netscope/netscope-apps-groups-viewer/apps-groups-files-nav/apps-groups-files-nav.component";
import {
  NetscopeAppsGroupsViewerComponent
} from "@app/netscope/netscope-apps-groups-viewer/netscope-apps-groups-viewer.component";
import {
  AppsGroupsMapComponent
} from "@app/netscope/netscope-apps-groups-viewer/apps-groups-map/apps-groups-map.component";
import {
  AppsGroupEditorComponent
} from "@app/netscope/netscope-apps-groups-viewer/apps-group-editor/apps-group-editor.component";
import {
  NewAppsGroupDialogComponent
} from "@app/netscope/netscope-apps-groups-viewer/new-apps-group-dialog/new-apps-group-dialog.component";

@NgModule({
  declarations: [
    EchartsItemCountDirective,
    NetscopeDashboardComponent,
    NetscopeHeatmapViewerComponent,
    NetscopeTopologyComponent,
    ExpandableRowsComponent,
    RangeFilterComponent,
    ResourceFilterComponent,
    HeatmapComboboxComponent,
    HeatmapHighchartsHeatmapComponent,
    NetscopeCustomProtocolsComponent,
    AppsGroupsComboboxComponent,
    NetscopeCommonFlowviewComponent,
    NetscopeExternalIpsComponent,
    ExternalIpsWizardImportCsvComponent,
    NetscopeDiagnosticComponent,
    NetscopeFlowsDatagridComponent,
    ResourcesComboboxComponent,
    NetscopeCommonFlowviewLegendComponent,
    NetscopeReportsComponent,
    NetscopeOutsideFlowsComponent,
    NetscopeThreatCenterComponent,
    DiscreteValuesFilterComponent,
    ThreatsTagsFilterComponent,
    AppsGroupElementComponent,
    NetscopeFlowsDescriptionsComponent,
    FlowsDescriptionsEditComponentComponent,
    FlowsDescriptionsNetworkRuleEditComponent,
    AppsGroupRefComponent,
    AppsGroupsPanelComponent,
    AppsGroupsFilesNavComponent,
    NetscopeAppsGroupsViewerComponent,
    AppsGroupsMapComponent,
    AppsGroupEditorComponent,
    NewAppsGroupDialogComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ClarityModule,
    AppRoutingModule,
    FontAwesomeModule,
    NgxSliderModule,
    TranslocoModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
      theme: ECHARTS_THEME
    }),
    MarkdownModule.forRoot(),
    CodeEditorModule
  ],
  exports: [
    MarkdownModule,
    AppsGroupsComboboxComponent
  ],
})
export class NetscopeModule {
}
